import { render } from "./RecordingTagsDialog.vue?vue&type=template&id=1288eb6b&scoped=true"
import script from "./RecordingTagsDialog.vue?vue&type=script&lang=js"
export * from "./RecordingTagsDialog.vue?vue&type=script&lang=js"

import "./RecordingTagsDialog.vue?vue&type=style&index=0&id=1288eb6b&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1288eb6b"]])

export default __exports__